import * as ng from 'angular';
import {LoginModule} from './login/login.module';
import {RegistrationModule} from './registration/registration.module';
import {UnsubscriptionModule} from './unsubscription/unsubscription.module';
import {HomeModule} from './home/home.module';
import {AdminModule} from './home/admin/admin.module';
import {MaintenanceModule} from './maintenance/maintenance.module';

export const SectionsModule: string = ng
  .module('app.sections', [
    'ui.bootstrap',
    LoginModule,
    RegistrationModule,
    UnsubscriptionModule,
    HomeModule,
    AdminModule,
    MaintenanceModule,
  ])
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/sections.module.ts